import React from 'react';
import {useSingleTheme} from '../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from '../../components/modules/pannelli/ThemesScreen';
import {SWHeadLinks} from '../../components/modules/pannelli/HeadLink';
import '../../components/modules/pannelli/themesScreen.scss';

function Etichette() {
    const {theme} = useSingleTheme('choosewines');
    const choosewines_Theme = theme;
    const {articles} = useArticles('choosewines');
    const article = articles.slice(1, 2) || [];
    const articles_Etichetta = article[0]; 
    const {paragraphs} = useParagraphs('choosewines_2');

    return (
        <section>
            {theme && <SWHeadLinks title={choosewines_Theme.tema_titolo} /> }
            <ThemesScreen theme={choosewines_Theme} article={articles_Etichetta} paragraphs={paragraphs}/> 
        </section>
    )
}
export default Etichette;
